const userRole = 'USER';

export default userRole;
